type Context = 'people';

type Section =
  | 'profile'
  | 'all'
  | 'slugs'
  | 'slug'
  | 'similar'
  | 'phones'
  | 'request-phone'
  | 'request-work-email'
  | 'dnc-check'
  | 'exchange';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  profile: 'people-profile',
  phones: 'people-phones',
  slugs: 'people-slugs',
  slug: 'people-slug',
  similar: 'people-similar',
  all: 'people-all',
  'request-phone': 'people-request-phone',
  'request-work-email': 'people-request-work-email',
  'dnc-check': 'people-dnc-check',
  exchange: 'people-exchange',
};
